module.exports = __webpack_public_path__ + "static/media/foodByPrescription-desktop.44c1b6d0.jpg";